import PropTypes from 'prop-types';
import React, { Component } from "react"
import classnames from "classnames"
import Icon from "../elements/Icon"

export default class LoadMoreLink extends Component {
  render() {
    var { extraClasses, ...other } = this.props

    const classNames = classnames("load-more", extraClasses)

    return (
      <a {...other} className={classNames} href="#">
        <span className="load-more__inner">
          <span>
            <Icon icon="load" /> {this.props.children}
          </span>
        </span>
      </a>
    )
  }
}

LoadMoreLink.propTypes = {
  extraClasses: PropTypes.string
}



// WEBPACK FOOTER //
// ./webapp/components/elements/LoadMoreLink.js